module.exports = __webpack_public_path__ + "img/set_radio.b66f7640.svg";